/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPayorFieldCondition
 */
export interface HchbPayorFieldCondition {
    /**
     * 
     */
    field: string;
    /**
     * 
     */
    operation: HchbPayorFieldConditionOperationEnum;
    /**
     * String, number, boolean, or null.
     */
    value?: any | null;
}


/**
 * @export
 */
export const HchbPayorFieldConditionOperationEnum = {
    Equals: 'equals',
    NotEquals: 'not_equals',
} as const;
export type HchbPayorFieldConditionOperationEnum = typeof HchbPayorFieldConditionOperationEnum[keyof typeof HchbPayorFieldConditionOperationEnum];


/**
 * Check if a given object implements the HchbPayorFieldCondition interface.
 */
export function instanceOfHchbPayorFieldCondition(value: object): value is HchbPayorFieldCondition {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('operation' in value) || value['operation'] === undefined) return false;
    return true;
}

export function HchbPayorFieldConditionFromJSON(json: any): HchbPayorFieldCondition {
    return HchbPayorFieldConditionFromJSONTyped(json, false);
}

export function HchbPayorFieldConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorFieldCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'operation': json['operation'],
        'value': json['value'] === undefined ? undefined : json['value'] === null ? null : json['value'],
    };
}

export function HchbPayorFieldConditionToJSON(json: any): HchbPayorFieldCondition {
    return HchbPayorFieldConditionToJSONTyped(json, false);
}

export function HchbPayorFieldConditionToJSONTyped(value?: HchbPayorFieldCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'operation': value['operation'],
        'value': value['value'],
    };
}

